import { useQuery } from '@tanstack/react-query';
import { getMe } from '../api.js';

/** `null` means signed out, not "still loading" — check `isLoading` for that. */
export function useMe() {
  return useQuery({ queryKey: ['me'], queryFn: getMe });
}
